module.exports = __webpack_public_path__ + "img/rating-touring-trans-2HqKTcY.svg";